export default function(callback) {
  if(typeof google == 'undefined') {
    var [lang, region] = window.langtag.split('-');
    var script = document.createElement('script');
    script.type= 'text/javascript';
    script.src= 'https://maps.googleapis.com/maps/api/js?key='+window.maps_api+'&language='+lang+'&region='+region+'&libraries=places';
    document.getElementsByTagName('body')[0].appendChild(script);
  }
}
